import { EntityStation } from '@/models';

/**
 * Station option for Autocomplete component
 */
export interface StationOption {
  label: string;
  id: string;
  name: string;
}

/**
 * Maps EntityStation from NERIS API to StationOption for UI
 * Note: In NERIS dictionary:
 *   - neris_id is the actual station ID
 *   - station_id is the station name
 */
export const mapEntityStationToStationOption = (
  station: EntityStation,
): StationOption => {
  return {
    id: station.neris_id,
    name: station.neris_id,
    label: `ID:${station.neris_id}(${station.station_id})`,
  };
};

/**
 * Maps array of EntityStations to array of StationOptions
 */
export const mapEntityStationsToStationOptions = (
  stations: EntityStation[],
): StationOption[] => {
  return stations.map(mapEntityStationToStationOption);
};
